import React from "react";
const Bookmaker = ({ onChildRuleShow, eventDetails,bookmakerOdds,setBetSlipDetails,bookmakerBook}) => {
 
  const showRules = () => {
    onChildRuleShow();
  };

  const showBetSlip = (betType,teamName,sid,rate,sr) => { 
    setBetSlipDetails({bet_type:betType,runnername:teamName,sid:sid,odds:rate,amount:0,market_type:'bm',sr:sr});
  };

  // runner1
  let r1b=0;
  let r1l=0; 
  let t2Size=0;
  let t3Size=0;
  let status1 = "SUSPENDED";

  // runner2
  let r2b=0; 
  let r2l=0;
  let t4Size=0;
  let t5Size=0; 
  let status2 = "SUSPENDED";

  // runner3
  let r3b=0; 
  let r3l=0; 

  let t6Size=0;
  let t7Size=0; 
  let status3 = "SUSPENDED";

  let rnr1s = 0;
  let rnr2s = 0;
  let rnr3s = 0;

  if(bookmakerBook!==null && bookmakerBook!==undefined)
  {
    rnr1s = parseInt(bookmakerBook.rnr1s);
    rnr2s = parseInt(bookmakerBook.rnr2s);
    rnr3s = parseInt(bookmakerBook.rnr3s); 
  }


  if(bookmakerOdds!==null && bookmakerOdds!==undefined && bookmakerOdds!=="") {
    //debugger;
    // runner1 
    r1b = bookmakerOdds.r1b; 
    r1l = bookmakerOdds.r1l; 
    t2Size = bookmakerOdds.t2Size; 
    t3Size = bookmakerOdds.t3Size; 
    status1 = bookmakerOdds.s1;

    //runner2
    r2b = bookmakerOdds.r2b; 
    r2l = bookmakerOdds.r2l; 
    t4Size = bookmakerOdds.t4Size; 
    t5Size = bookmakerOdds.t5Size;
    status2 = bookmakerOdds.s2;

    // runner3
    r3b = bookmakerOdds.r3b;
    r3l = bookmakerOdds.r3l;
    t6Size = bookmakerOdds.t6Size; 
    t7Size = bookmakerOdds.t7Size;
    status3 = bookmakerOdds.s3;

  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="tb-content" id="bookmaker_div" style={{ display: "" }}>
      <div>
        <div className="market-titlebar">
          <p className="market-name">
            <span className="market-name-badge">
              <i className="market-name-icon">
                <img
                  src="/assets/images/time-img.png"
                  style={{
                    filter: "invert(100%)",
                    marginTop: "-8px",
                    marginLeft: "-1px"
                  }}
                />
              </i>
              <span>
                BOOKMAKER{" "}
                <span style={{ textTransform: "initial" }}>(MaxBet: 2M)</span>{" "}
              </span>{" "}
            </span>
            <span className="rules-badge">
              <i className="fa fa-info-circle"></i>
            </span>
          </p>
          <div className="market-overarround">
            <span></span>
            <strong>Back</strong>
          </div>
          <div className="market-overarround market-overarround-lay">
            <strong>Lay</strong>
          </div>
        </div>

        <div className="market-runners">
          <div className="runner-runner">
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              whiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr1}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              color: rnr1s >= 0 ? "green" : "red",
                              display: rnr1s != 0 ? "" : "none"
                            }}
                          >
                            {formatTruncate(Math.round(rnr1s))}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>
            <div className="price-row-box-new">
              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a
                className="price-price price-back mb-show"
                style={{ backgroundColor: "rgb(141, 210, 240)" }}
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1b,
                    1
                  )
                }
              >
                <div id="runner1b1span_b">
                  <span className="price-odd" style={{ fontSize: "18px" }}>
                    {r1b}
                  </span>
                  <span className="price-amount" id="t2Size">
                    {t2Size}
                  </span>
                </div>
              </a>

              <a
                className="price-price price-lay ml-4 mb-show"
                style={{ backgroundColor: "rgb(254, 175, 178)" }}
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr1,
                    eventDetails.cat_sid1,
                    r1l,
                    1
                  )
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "18px" }}>
                    {r1l}
                  </span>
                  <span className="price-amount" id="t3Size">
                    {t3Size}
                  </span>
                </div>
              </a>

              <a className="price-price price-lay">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-lay mr-4">
                <div>&nbsp;</div>
              </a>
              <div
                className="suspended-overlap"
                style={{ display: status1 === "SUSPENDED" ? "" : "none" }}
              >
                Suspended
              </div>
            </div>
          </div>

          <div className="runner-runner" style={{ marginTop: "6px" }}>
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              whiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr2}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              color: rnr2s >= 0 ? "green" : "red",
                              display: rnr2s != 0 ? "" : "none"
                            }}
                          >
                            {formatTruncate(Math.round(rnr2s))}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a
                className="price-price price-back mb-show"
                data-team="South Africa"
                data-market-type="bm"
                data-bm-sr="2"
                style={{ backgroundColor: "rgb(141, 210, 240)" }}
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2b,
                    2
                  )
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "19px" }}>
                    {r2b}
                  </span>
                  <span className="price-amount" id="t4Size">
                    {t4Size}
                  </span>
                </div>
              </a>

              <a
                className="price-price price-lay ml-4 mb-show"
                data-team="South Africa"
                data-market-type="bm"
                data-bm-sr="2"
                style={{ backgroundColor: "rgb(254, 175, 178)" }}
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr2,
                    eventDetails.cat_sid2,
                    r2l,
                    2
                  )
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "19px" }}>
                    {r2l}
                  </span>
                  <span className="price-amount">{t5Size}</span>
                </div>
              </a>

              <a className="price-price price-lay">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-lay mr-4">
                <div>&nbsp;</div>
              </a>
              <div
                className="suspended-overlap"
                style={{ display: status2 === "SUSPENDED" ? "" : "none" }}
              >
                Suspended
              </div>
            </div>
          </div>

          <div
            className="runner-runner"
            style={{
              marginTop: "6px",
              display: eventDetails.cat_rnr3 === "NA" ? "none" : ""
            }}
          >
            <h3 className="runner-name">
              <div className="runner-info">
                <span className="clippable runner-display-name">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <h4
                            style={{
                              marginBottom: "0px",
                              fontSize: "16px",
                              fontWeight: "600",
                              whiteSpace: "normal"
                            }}
                            className="clippable-spacer"
                          >
                            {eventDetails.cat_rnr3}
                          </h4>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div
                            style={{
                              float: "left",
                              fontSize: "15px",
                              display: rnr3s != 0 ? "" : "none",
                              color: rnr3s >= 0 ? "green" : "red"
                            }}
                          >
                            {formatTruncate(Math.round(rnr3s))}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </div>
            </h3>

            <div className="price-row-box-new">
              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-back">
                <div>&nbsp;</div>
              </a>

              <a
                className="price-price price-back mb-show"
                data-team="South Africa"
                data-market-type="bm"
                data-bm-sr="2"
                style={{ backgroundColor: "rgb(141, 210, 240)" }}
                onClick={() =>
                  showBetSlip(
                    "b",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3b,
                    3
                  )
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "19px" }}>
                    {r3b}
                  </span>
                  <span className="price-amount">{t6Size}</span>
                </div>
              </a>

              <a
                className="price-price price-lay ml-4 mb-show"
                data-team="South Africa"
                data-market-type="bm"
                data-bm-sr="2"
                style={{ backgroundColor: "rgb(254, 175, 178)" }}
                onClick={() =>
                  showBetSlip(
                    "l",
                    eventDetails.cat_rnr3,
                    eventDetails.cat_sid3,
                    r3l,
                    3
                  )
                }
              >
                <div>
                  <span className="price-odd" style={{ fontSize: "19px" }}>
                    {r3l}
                  </span>
                  <span className="price-amount">{t7Size}</span>
                </div>
              </a>

              <a className="price-price price-lay">
                <div>&nbsp;</div>
              </a>

              <a className="price-price price-lay mr-4">
                <div>&nbsp;</div>
              </a>
              <div
                className="suspended-overlap"
                style={{ display: status3 === "SUSPENDED" ? "" : "none" }}
              >
                Suspended
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Bookmaker;